import { act } from "react-dom/test-utils";
import {
  LOG_IN,
  LOG_IN_ADMIN,
  CHECK_ADMIN,
  FETCH_USER,
  CREATE_ACCOUNT,
  VERIFY_ACCOUNT,
  VERIFY_EDITED_ACCOUNT,
  UPDATE_EDITED_ACCOUNT,
  UPDATE_PREFERENCES,
  PASSWORD_RESET_STATUS,
  LOG_OUT,
  VALIDATE_LANGUAGE_HASH,
  UPDATE_LANGUAGE,
} from "../actions/types";
import axios from "axios";
import languageReducer from "./languageReducer";

const initialState = {
  isCompany: false,
  guestUser: false,
  isAdmin: false,
  wasAdmin: false,
  loggedIn: false,
  token: "",
  refreshtoken: "",
  createdAccount: false,
  verifyAccount: false,
  verifyEditedAccount: false,
  invalidLogin: false,
  isPasswordCodeSent: false,
  tempEmail: "",
  changedEmail: false,
  accountData: {},
  preferences: {
    currency: "€",
    separator: ",",
  },
  translationNeedsReload: true,
  hash: "",
};

export default function accountReducer(state = initialState, action) {
  switch (action.type) {
    case LOG_IN: {
      axios.defaults.headers.common["token"] = action.payload.token;
      axios.defaults.headers.common["refreshtoken"] =
        action.payload.refreshtoken;

      return {
        ...state,
        loggedIn: action.payload.token ? true : false,
        wasAdmin: false,
        token: action.payload.token,
        refreshtoken: action.payload.refreshtoken,
        guestUser: action.payload.guestUser,
        createdAccount: false,
        verifyAccount: false,
        verifyEditedAccount: false,
        invalidLogin: false,
        isPasswordCodeSent: false,
        tempEmail: "",
        changedEmail: false,
        accountData: {
          id: action.payload.id,
          name: action.payload.name,
          avatar: action.payload.imageContent,
        },
      };
    }
    case LOG_IN_ADMIN: {
      axios.defaults.headers.common["token"] = action.payload.token;
      axios.defaults.headers.common["refreshtoken"] =
        action.payload.refreshtoken;
      return {
        ...state,
        loggedIn: action.payload.token ? true : false,
        token: action.payload.token,
        refreshtoken: action.payload.refreshtoken,
        isAdmin: true,
        createdAccount: false,
        verifyAccount: false,
        verifyEditedAccount: false,
        invalidLogin: false,
        accountData: {
          id: action.payload.id,
          name: action.payload.name,
          avatar: action.payload.imageContent,
        },
      };
    }
    case CHECK_ADMIN: {
      axios.defaults.headers.common["token"] = action.payload.token;
      axios.defaults.headers.common["refreshtoken"] =
        action.payload.refreshtoken;
      return {
        ...state,
        loggedIn: action.payload.token ? true : false,
        token: action.payload.token,
        refreshtoken: action.payload.refreshtoken,
        isAdmin: true,
        createdAccount: false,
        verifyAccount: false,
        verifyEditedAccount: false,
        invalidLogin: false,
      };
    }

    case VALIDATE_LANGUAGE_HASH: {
      return {
        ...state,
        translationNeedsReload: !!action.payload.translationNeedsReload,
        hash: action.payload.hash,
      };
    }

    case FETCH_USER: {
      return {
        ...state,
        accountData: {
          ...state.accountData,

          name: action.payload.name,
          avatar: action.payload.imageContent + "?v=" + Date.now(),
          internationalPrefix: action.payload.internationalPrefix,
          phone: action.payload.mobile,
          email: action.payload.email,
          country: action.payload.country,
          places: action.payload.referencePlaces || [],
          billingAddress: action.payload?.billingProfile?.billingAddress || [],
          isBankTransferEnabled: action.payload.isBankTransferEnabled || false,
          isMBRefEnabled: action.payload.isMBRefEnabled || false,
          evioComission: action.payload.evioCommission,
          userPackage: action.payload.userPackage,
        },
        language: action.payload.language,
        licenseAgreement: action.payload.licenseAgreement,
        licenseMarketing: action.payload.licenseMarketing,
        licenseProducts: action.payload.licenseProducts,
        licenseServices: action.payload.licenseServices,
        isCompany: action.payload.clientType === "b2b",
      };
    }
    case CREATE_ACCOUNT: {
      return {
        ...state,
        createdAccount: true,
        verifyAccount: false,
        verifyEditedAccount: false,
        accountData: action.payload.data,
      };
    }
    case VERIFY_ACCOUNT: {
      window.location.assign("../login");
      return {
        ...state,
        verifyAccount: action.payload,
      };
    }
    case PASSWORD_RESET_STATUS: {
      return {
        ...state,
        tempEmail: action.payload.tempEmail,
        isPasswordCodeSent: action.payload.isPasswordCodeSent,
      };
    }
    case VERIFY_EDITED_ACCOUNT: {
      window.location.assign("../login");
      return {
        ...state,
        verifyEditedAccount: action.payload,
        tempEmail: "",
        changedEmail: false,
      };
    }
    case UPDATE_EDITED_ACCOUNT: {
      return {
        ...state,
        verifyEditedAccount: action.payload.verifyEditedAccount,
        tempEmail: action.payload.tempEmail,
        changedEmail: true,
      };
    }
    case UPDATE_PREFERENCES: {
      return {
        ...state,
        preferences: action.payload,
      };
    }
    case LOG_OUT: {
      return {
        ...state,
        loggedIn: false,
        guestUser: false,
        isAdmin: false,
        wasAdmin: action.payload.wasAdmin,
        isCompany: false,
        token: "",
        refreshtoken: "",
        createdAccount: false,
        verifyAccount: false,
        isPasswordCodeSent: false,
        verifyEditedAccount: false,
        invalidLogin: action.payload.invalidLogin,
        accountData: {},
      };
    }
    default:
      return state;
  }
}
